export default __webpack_public_path__ + "static/media/Series-9200-MPNH-Insertion-Remote-FAT.b4cbeb04.png";